import React from 'react'
import { formatAmount } from 'utils/organization-utils'
import { formatDate } from 'utils/date-utils'

interface LineItem {
  id: string
  amount: number
  amount_excluding_tax: number
  currency: string
  description: string
  discount_amounts: any[]
  discounts: any[]
  invoice: any
  invoice_item: any
  livemode: boolean
  metadata: any
  parent: any
  period: {
    end: number
    start: number
  }
  plan: any
  pretax_credit_amounts: any[]
  price: any
  pricing: any
  proration: boolean
  proration_details: any
  quantity: number
  subscription: any
  subscription_item: any
  tax_amounts: any[]
  tax_rates: any[]
  taxes: any
  type: string
  unit_amount_excluding_tax: string
}

interface InvoiceProductsListProps {
  lineItems: LineItem[]
}

const InvoiceProductsList: React.FC<InvoiceProductsListProps> = ({
  lineItems,
}) => {
  // Filter items: show 0 quantity items only if there are no non-zero items
  const hasNonZeroItems = lineItems.some((item) => item.quantity !== 0)
  const filteredLineItems = hasNonZeroItems
    ? lineItems.filter((item) => item.quantity !== 0)
    : lineItems

  return (
    <div style={{ marginBottom: '16px' }}>
      <table
        style={{
          width: '100%',
          borderCollapse: 'collapse',
          fontSize: '11px',
        }}
      >
        <thead>
          <tr style={{ borderBottom: '2px solid #c1c7cd' }}>
            <th
              style={{
                textAlign: 'left',
                padding: '8px 0',
                fontWeight: '600',
                color: '#000000',
                fontSize: '11px',
              }}
            >
              Description
            </th>
            <th
              style={{
                textAlign: 'right',
                padding: '8px 0',
                fontWeight: '600',
                color: '#000000',
                fontSize: '11px',
              }}
            >
              Quantity
            </th>
            <th
              style={{
                textAlign: 'right',
                padding: '8px 0',
                fontWeight: '600',
                color: '#000000',
                fontSize: '11px',
              }}
            >
              Unit Price
            </th>
            <th
              style={{
                textAlign: 'right',
                padding: '8px 0',
                fontWeight: '600',
                color: '#000000',
                fontSize: '11px',
              }}
            >
              Amount
            </th>
          </tr>
        </thead>
        <tbody>
          {filteredLineItems.map((item) => {
            const {
              description,
              quantity,
              unit_amount_excluding_tax: unitPrice,
              amount,
              period,
              price,
            } = item

            // Use price.unit_amount if unit_amount_excluding_tax is null
            const actualUnitPrice =
              unitPrice || (price?.unit_amount ? price.unit_amount : null)

            // Clean description by removing quantity and pricing information
            const cleanDescription = description
              .replace(/^\d+\s*×\s*/, '') // Remove "19 × " from start
              .replace(/\s*\(at \$[\d,]+\.\d+\s*\/\s*month\)/g, '') // Remove pricing info
              .replace(/\s*19\*/g, '') // Remove "19*" pattern

            return (
              <tr key={item.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                <td
                  style={{
                    padding: '8px 0',
                    color: '#000000',
                    fontSize: '11px',
                  }}
                >
                  <div style={{ fontWeight: '500' }}>{cleanDescription}</div>
                  <div
                    style={{
                      color: '#6b7c93',
                      fontSize: '10px',
                      marginTop: '2px',
                    }}
                  >
                    {period.start === period.end
                      ? '' // Show nothing if same dates
                      : `${formatDate(period.start)} - ${formatDate(
                          period.end
                        )}`}
                  </div>
                </td>
                <td
                  style={{
                    textAlign: 'right',
                    padding: '8px 0',
                    color: '#000000',
                    fontSize: '11px',
                  }}
                >
                  {quantity}
                </td>
                <td
                  style={{
                    textAlign: 'right',
                    padding: '8px 0',
                    color: '#000000',
                    fontSize: '11px',
                  }}
                >
                  {actualUnitPrice
                    ? Number(actualUnitPrice) < 0
                      ? `-${formatAmount(Math.abs(Number(actualUnitPrice)))}`
                      : formatAmount(actualUnitPrice)
                    : 'N/A'}
                </td>
                <td
                  style={{
                    textAlign: 'right',
                    padding: '8px 0',
                    color: '#000000',
                    fontSize: '11px',
                    fontWeight: '500',
                  }}
                >
                  {amount < 0
                    ? `-${formatAmount(Math.abs(amount))}`
                    : formatAmount(amount)}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default InvoiceProductsList
